const projectsActionsTypes = {
    ADD_PROJECT:'ADD_PROJECT',
    SET_PROJECTS:'SET_PROJECTS'
}

export default projectsActionsTypes;